const state = {

    refresh_key: 0,

    customer_id: null,
    contact_id: null,
    company_id: null,
    settings_id: null,
    address_id: null,

    showContacts: true,
    showCompanies: true,

    contactDialog: false,
    contactMetaDialog: false,
    contactAchTokenDialog: false,
    contactCardTokenDialog: false,
    contactNotesDialog: false,
    contactSelectDialog: false,

    companyDialog: false,
    companyMetaDialog: false,
    companyAchTokenDialog: false,
    companyCardTokenDialog: false,
    companyNotesDialog: false,
    companySelectDialog: false,
    companyPaymentDialog: false,

    settingsDialog: false,
    selectCustomerDialog: false,
    selectAddressDetailDialog: false,
    selectAddressDialog: false,

    processPaymentDialog: false,
    addressDetailDialog: false,
    addressNotesDialog: false,

    header: true,
    titlebar: true,
    events: false,

    labels: {
        customer_list: "Customer List"
    },

};

const getters = {};

const mutations = {};

const actions = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
